import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import ThankYouPage from './pages/ThankYouPage';
import Header from './components/Header/Header';
import LandingPage from './components/LandingPage';
import Footer from './components/Footer';

const App = () => {
  return (
    <Router>
      <div className="bg-white flex flex-col items-center">
        <Header />

        <Routes>
          <Route path="" element={<LandingPage />} />
          <Route path="/thank-you" element={<ThankYouPage />} />
        </Routes>

        <Footer />
      </div>
    </Router>
  );
};

export default App;
